import {Vue} from 'ui.vue';



import './BXmakerAuthuserphoneMessage.styl';

Vue.component('BXmakerAuthuserphoneMessage',
    {
        props:{
            message: {
                type: [String, Boolean],
                default: false,
            },
            error: {
                type: [Boolean],
                default: false,
            },
        },
        computed:{
            classes(){
                let ar = [];
                if(this.error)
                {
                    ar.push('bxmaker-authuserphone-message--error');
                }
                else if(this.message.toString().length > 0)
                {
                    ar.push('bxmaker-authuserphone-message--success');
                }
                return ar;
            }

        },
        template: `
            <div class="bxmaker-authuserphone-message" :class="classes" v-if="message" v-html="message" />
        `,
    });